import { getLocale, setLocale } from '@/i18n/locale';

// Floating 繁體/简体 switch, shown site-wide. Marked data-noconvert so its own
// labels are never rewritten by the converter.
const LocaleToggle = () => {
  const loc = getLocale();
  return (
    <div
      data-noconvert
      className="fixed bottom-4 left-4 z-50 flex items-center bg-white border border-[#E5E0D8] rounded-full shadow-md overflow-hidden text-sm"
    >
      <button
        type="button"
        onClick={() => loc !== 'hant' && setLocale('hant')}
        className={`px-3 py-1.5 transition-colors ${loc === 'hant' ? 'bg-[#C93B2B] text-white' : 'text-[#5C5C5C] hover:bg-[#F5F0E6]'}`}
        data-testid="locale-hant"
      >
        繁體
      </button>
      <button
        type="button"
        onClick={() => loc !== 'hans' && setLocale('hans')}
        className={`px-3 py-1.5 transition-colors ${loc === 'hans' ? 'bg-[#C93B2B] text-white' : 'text-[#5C5C5C] hover:bg-[#F5F0E6]'}`}
        data-testid="locale-hans"
      >
        简体
      </button>
    </div>
  );
};

export default LocaleToggle;
